import { AnyAction } from 'redux';

import { PLAN_TIER } from '@wetransfer/transfer/constant/plan-tier';
import { State } from '@wetransfer/transfer/store/types';

enum ACTIONS {
  SET_TIER_USER = '@WEDEBUG/SET_TIER_USER',
}

export const setUserTier = (tier: PLAN_TIER): AnyAction => ({
  type: ACTIONS.SET_TIER_USER,
  tier,
});

const debugUserReducer = (state: State, action: AnyAction): State => {
  switch (action.type) {
    case ACTIONS.SET_TIER_USER:
      return {
        ...state,
        user: {
          ...state.user,
          planTier: action.tier,
        },
      };
  }
};

export default debugUserReducer;
